import { Observable } from 'rxjs/Observable'
import { Subject } from 'rxjs/Subject'
import 'rxjs/add/operator/do'

import { InfinitePaginator } from './components/infinite-paginator'
import { InfinitePaginatorModule } from './components/infinite-paginator.module'

interface Page<T> {
  items: T[]
  next: number
  prev: number
  total: number
}

type pageLoader<T> = (page: number) => Observable<Page<T>>

class PaginatedList<T> {
  page: Page<T>
  _items: T[]
  // TODO: BehaviorSubjectの方が良いかも
  // ただし初期値の場合の挙動が怪しい
  itemsSubject: Subject<T[]>
  lastPageSubject: Subject<T[]>
  ended: boolean

  public get items(): Observable<T[]> {
    return this.itemsSubject as Observable<T[]>
  }

  public get lastPage(): Observable<T[]> {
    return this.lastPageSubject as Observable<T[]>
  }

  constructor(private loadPage: pageLoader<T>, initialPage = 1) {
    this._items = null
    this.itemsSubject = new Subject<T[]>()
    this.lastPageSubject = new Subject<T[]>()
    this.ended = false

    // load initial page
    this.load(initialPage).subscribe((p) => {
      this._items = p.items
      this.itemsSubject.next([...this._items])
    })

    this.lastPageSubject.subscribe((items) => {
      this._items = this._items.concat(items)
      this.itemsSubject.next([...this._items])
    })
  }

  private load(page: number): Observable<Page<T>> {
    return this.loadPage(page).do((p) => {
      this.page = p
    })
  }

  public loadNextPage(): Observable<boolean> {
    return this.load(this.page.next).map((page) => {
      if(!this.ended) {
        if (this.page.items.length === 0) {
          this.ended = true
          return false
        }
        this.lastPageSubject.next(page.items)
        return true
      } else {
        return false
      }
    })
  }

  public unshift(item: T) {
    this._items.unshift(item)
    this.itemsSubject.next([...this._items])
  }

  public push(item: T) {
    this._items.push(item)
    this.itemsSubject.next([...this._items])
  }
}

export {
  InfinitePaginator,
  InfinitePaginatorModule,
  Page,
  PaginatedList,
}



// WEBPACK FOOTER //
// ./src/libs/infinite-paginator/index.ts